"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExcelLikeGrid = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var Row_1 = require("./Row");
function ExcelLikeGrid(props) {
    var grid = props.grid, onButtonClicked = props.onButtonClicked, onValueUpdate = props.onValueUpdate;
    var gridData = grid.data;
    var numOfColumn = gridData[0]
        ? (0, lodash_1.sumBy)(gridData[0], function (x) { return x.colSpan || 1; })
        : 0;
    return ((0, jsx_runtime_1.jsx)("table", __assign({ className: "ExcelTable" }, { children: (0, jsx_runtime_1.jsxs)("tbody", { children: [(0, jsx_runtime_1.jsx)("tr", __assign({ style: { visibility: "hidden" } }, { children: (0, lodash_1.range)(numOfColumn).map(function (x, keys) { return ((0, jsx_runtime_1.jsx)("td", { style: { width: "".concat((1 / numOfColumn) * 100, "%") } }, keys)); }) })), gridData.map(function (data, dataI) {
                    return ((0, jsx_runtime_1.jsx)("tr", __assign({ style: { height: 36 } }, { children: data.map(function (cell, i) {
                            var _a;
                            if (cell == null)
                                return;
                            return ((0, jsx_runtime_1.jsx)(Row_1.RowView, { cell: cell, onValueUpdate: onValueUpdate, onButtonClicked: onButtonClicked, mode: (_a = cell.mode) !== null && _a !== void 0 ? _a : null }, i));
                        }) }), dataI));
                })] }) })));
}
exports.ExcelLikeGrid = ExcelLikeGrid;
